import { Button, Grid } from '@mui/material';
import styled from '@emotion/styled';
import { AssetComponent } from '../../../../redux/slices/slice_types';
import { applyFilter, clearFilters, setCurrentTable } from '../../../../redux/slices/dataTableSlice';
import { useHistory } from 'react-router-dom';
import { useAppDispatch } from '@/redux/hooks';

interface ViewJobAssetButtonProps {
  asset: AssetComponent;
}

const ViewJobAssetButton = ({ asset }: ViewJobAssetButtonProps) => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  if (!asset.job_asset_id) {
    console.log('No job asset ID to link to.');
    return null;
  }

  const onButtonClick = () => {
    // KYLE: not removing right now, but I believe all this line does is clear the jobs table filters which seems wrong
    dispatch(clearFilters());
    dispatch(setCurrentTable('pendingAssets'));
    dispatch(clearFilters());
    dispatch(applyFilter({ type: 'filter_id', selections: [asset.job_asset_hid, 'job_hid_filter'] }));
    history.push(`/pending-assets`);
  };

  return (
    <Grid container justifyContent="flex-end">
      <ViewAssetButton size="small" variant="text" color="warning" onClick={onButtonClick} sx={{ mt: -1 }}>
        View Asset
      </ViewAssetButton>
    </Grid>
  );
};

export default ViewJobAssetButton;

const ViewAssetButton = styled(Button)`
  margin-bottom: ${({ theme }) => theme.spacing(0.5)};
  font-size: 0.84rem;
  opacity: 0.8;
  transition: opacity 0.2s ease;
  &:hover {
    background: none;
    opacity: 1;
    transition: opacity 0.2s ease;
  }
`;
